import { ReactComponent as SoundOutlined } from "../../assets/images/soundOutlined.svg";
import { ReactComponent as MutedOutlined } from "../../assets/images/mutedOutlined.svg";
import { ReactComponent as Dragon } from "../../assets/images/dragon-fruifft.svg";
import { ReactComponent as Lock } from "../../assets/images/lock.svg";

const ControlPanel = ({ onChangeCount, isPlayed, count, toggleSound, isOnSound, isLocked }) => {
	return (
		<div className="controls">
			<button
				onClick={() => onChangeCount("2")}
				className={`switcher-btn ${count === "2" ? "selected" : ""} ${isPlayed ? "played" : ""}`}>
				<Dragon />
				<Dragon />
			</button>
			<button
				onClick={() => onChangeCount("3")}
				className={`switcher-btn ${count === "3" ? "selected" : ""} ${isPlayed ? "played" : ""}`}>
				<Dragon />
				<Dragon />
				{isLocked ? <Dragon /> : <Lock />}
			</button>

			<button className="control-btn" onClick={toggleSound}>
				{isOnSound ? <SoundOutlined /> : <MutedOutlined style={{ opacity: 0.7 }} />}
			</button>
		</div>
	);
};

export default ControlPanel;
